<h3 title-sm class="disclaimer">{{disclaimer}}</h3>
<br />
<div class="ag-theme-balham">
  <div content style="display: flex" class="scroll-div">
    <div style="flex: 1">
      <ag-grid-angular
        class="grid-settings ag-theme-density zebra ag-theme-bmw ag-theme-balham grid-struct ag-theme-quartz"
        style="width: 100%"
        [style.height]="scrollHeight"
        [rowHeight]="rowHeight"
        [rowData]="rowData"
        [columnDefs]="columns"
        [rowSelection]="'multiple'"
        [defaultColDef]="defaultColDef"
        [overlayNoRowsTemplate]="noRowsTemplate"
        [cacheBlockSize]="10"
        [theme]="theme"
        [pagination]="true"
        [paginationPageSize]="paginationPageSize"
        [paginationPageSizeSelector]="paginationPageSizeSelector"
        [rowBuffer]="50"
        [pinnedBottomRowData]="displayedPinnedBottomRowData"
        [headerHeight]="headerHeight"
        [suppressRowClickSelection]="true"
        [enableCellTextSelection]="true"
        [ensureDomOrder]="true"
        (gridReady)="onGridReady($event)"
        (filterChanged)="onFilterChanged()"
        (paginationChanged)="onPaginationChanged()"
      >
      </ag-grid-angular>
      <br />
    </div>
  </div>
  <ds-box>
    <div
      class="action-bar"
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        margin-left: 10px;
      "
    >
      <div *ngIf="isBackButtonPresent" class="actions-left">
        <ds-button tone="action" size="lg" (click)="goBack()">Back</ds-button>
      </div>
      <div class="actions-right">
        <div class="action-row" style="margin-right: 2px">
          <h3 class="title-sm">Export:</h3>
          <ds-button
            tone="action"
            size="md"
            aria-label="Export PDF"
            ds-loading
            [isLoading]="loadingKey() === 'pdf-export'"
            [disabled]="loadingKey() === 'pdf-export'"
            (click)="downloadApiImplementation('pdf','export')"
          >
            <ds-icon icon="file_pdf" size="lg" tone="action"></ds-icon>
          </ds-button>
          <ds-button
            tone="action"
            size="md"
            aria-label="Export CSV"
            ds-loading
            [isLoading]="loadingKey() === 'csv-export'"
            [disabled]="loadingKey() === 'csv-export'"
            (click)="downloadApiImplementation('csv','export')"
          >
            <ds-icon icon="file_excel" size="lg" tone="action"></ds-icon>
          </ds-button>
        </div>
        <div class="action-row" style="margin-right: 2px">
          <h3 class="title-sm">Total Dealer VIN ({{totalVechileCountSum}}):</h3>
          <ds-button
            tone="action"
            size="md"
            aria-label="Export PDF"
            ds-loading
            [isLoading]="loadingKey() === 'pdf-total'"
            [disabled]="loadingKey() === 'pdf-total'"
            (click)="downloadApiImplementation('pdf','total')"
          >
            <ds-icon icon="file_pdf" size="lg" tone="action"></ds-icon>
          </ds-button>
          <ds-button
            tone="action"
            size="md"
            aria-label="Export CSV"
            ds-loading
            [isLoading]="loadingKey() === 'csv-total'"
            [disabled]="loadingKey() === 'csv-total'"
            (click)="downloadApiImplementation('csv','total')"
          >
            <ds-icon icon="file_excel" size="lg" tone="action"></ds-icon>
          </ds-button>
        </div>
      </div>
    </div>
  </ds-box>
</div>
